<template>
  <div>
    <c-tab
      type="horizon"
      :inlineLabel="true"
      :dense="true"
      :height="tabHeight"
      :tabItems="tabItems"
      v-model="tab"
    >
      <template v-slot:default="tab">
        <component
          :is="tab.component"
          :key="tab.key"
          :popupParam="popupParam"
          :nearAccident.sync="nearAccident"
          :isOld="isOld"
          :height="tabHeight"
          :attachInfo1="attachInfo1"
          :attachInfo2="attachInfo2"
          isApprDisabled
          @getDetail="getDetail"
          @closePopup="closePopup"
        />
      </template>
    </c-tab>
  </div>
</template>
<script>
import { uid } from 'quasar'
import selectConfig from '@/js/selectConfig';
export default {
  name: 'nearAccidentDetailAppr',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        iimAccidentId: '',
      }),
    },
    contentHeight: null,
  },
  data() {
    return {
      nearAccident: {
        iimNearAccidentId: '',
        plantCd: '',
        iimNearAccidentNo: '',
        iimNearAccidentName: '',
        iimStatusNearCd: '',
        reportUserId: '',
        reportDt: '',
        iimNearKindCds: '',
        iimGradeCd: null,
        discovererId: '',
        occurrenceDt: '',
        occurrenceLocation: '',
        weatherCd: 'WC000001',
        emergencyMeasures: '',
        overviewAccidentSituation: '',
        occurrenceModeLargeCd: null,
        occurrenceModeSmallCd: null,
        directCause: '',
        indirectCause: '',
        openning: '',
        injurious: '',
        iimNearDiscernCds: null,
        iimNearFunctionCds: null,
        iimNearFeelCds: null,
        iimNearEquipCds: null,
        iimNearManageCds: null,
        processCd: '',
        frequencyRisk: '',
        strengthRisk: '',
        totalRisk: '',
        ramRiskAssessmentPlanId: '',
        bounty: 0,
        approvalRequestStatusCd: '', // 결재관련 결재상태 요청승인
        sysApprovalRequestRequestId: '', // 결재관련 결재요청코드 요청승인
        approvalReviewStatusCd: '', // 결재관련 결재상태 검토승인
        sysApprovalReviewRequestId: '', // 결재관련 결재요청코드 검토승인
        approvalAuditStatusCd: '', // 결재관련 결재상태 심사승인
        sysApprovalAuditRequestId: '', // 결재관련 결재요청코드 심사승인
        preventions: [],
      },
      attachInfo1: {
        isSubmit: '',
        taskClassCd: 'NEAR_FIRST_PICTURE',
        taskKey: '',
      },
      attachInfo2: {
        isSubmit: '',
        taskClassCd: 'NEAR_SECOND_PICTURE',
        taskKey: '',
      },
      tab: 'info',
      editable: true,
      detailUrl: '',
    };
  },
  computed: {
    isOld() {
      return Boolean(this.popupParam.iimNearAccidentId)
    },
    tabHeight() {
      return String(this.contentHeight - 60);
    },
    tabItems() {
      let items = [{ name: 'info', icon: 'edit', label: '아차사고 정보', component: () => import(`${'@/pages/sop/iim/near/nearRegisterTab.vue'}`), key: uid() }]
      if (this.nearAccident.iimStatusNearCd === 'ISNC000002') {
        items.push({ name: 'prevention', icon: 'construction', label: '원인 및 재발방지 관리', component: () => import(`${'@/pages/sop/iim/near/nearCausePrevention.vue'}`), key: uid() })
      } else if (this.nearAccident.iimStatusNearCd === 'ISNC000003' || this.nearAccident.iimStatusNearCd === 'ISNC000004') {
        items.push({ name: 'prevention', icon: 'construction', label: '원인 및 재발방지 관리', component: () => import(`${'@/pages/sop/iim/near/nearCausePrevention.vue'}`), key: uid() })
        items.push({ name: 'audit', icon: 'gavel', label: '심사', component: () => import(`${'@/pages/sop/iim/near/nearAudit.vue'}`), key: uid() })
      }
      return items;
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.detailUrl = selectConfig.sop.iim.accident.near.get.url;
      // code setting
      // list setting  
      this.getDetail();
    },
    getDetail(flag) {   //상세페이지 항목들에 저장된 값들을 가져오는 부분
      this.$http.url = this.$format(this.detailUrl, this.popupParam.iimNearAccidentId);
      this.$http.type = 'GET'; 
      this.$http.request((_result) => {
        if (!flag) {
          this.$_.extend(this.nearAccident, _result.data);
          this.$set(this.attachInfo1, 'taskKey', this.popupParam.iimNearAccidentId)
          this.$set(this.attachInfo2, 'taskKey', this.popupParam.iimNearAccidentId)
          this.$emit('transInfo', _result.data);
        } else if (flag === 'planOpinion') {
          this.$_.extend(this.nearAccident, this.$_.omit(_result.data, ['preventions']));
        } else if (flag === 'prevention') {
          this.$_.extend(this.nearAccident, this.$_.pick(_result.data, ['preventions']));
        }
          
          let tabName = 'info';
          if (this.nearAccident.iimStatusNearCd === 'ISNC000002') {
            tabName = 'prevention';
          } else if (this.nearAccident.iimStatusNearCd === 'ISNC000003' || this.nearAccident.iimStatusNearCd === 'ISNC000004') {
            tabName = 'audit';
          }
          this.$set(this.$data, 'tab', tabName)
      },);
    },
    closePopup(data) {
      this.$emit('closePopup', data);  
    },
  }
};
</script>
